import { createContext } from 'react'
import { EOnboardingStep, TOnboardingContext } from './types'
import { AccountModel, UserModel } from '@cakemail-org/ui-components-v2'

export const OnboardingContext = createContext<TOnboardingContext>({
    userForm: new UserModel({}),
    setUserForm: () => { },
    industryForm: {
        industry: "",
        sector: "",
        teamSize: ""
    },
    setIndustryForm: () => { },
    companyForm: new AccountModel({}),
    setCompanyForm: () => { },
    brandForm: {},
    setBrandForm: () => { },
    onOnboardingCompleted: () => { },
    step: EOnboardingStep.user,
    setStep: () => { },
    enrichedPerson: null,
    setEnrichedPerson: () => { },
    enrichedBrand: null,
    setEnrichedBrand: () => { },
    handleNext: () => { },
    isAgency: false,
    setIsAgency: () => { }
})